/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue } from '../../app.vues'
//
// 资质类型选择对话框
import SwbQualiTypeSelect from './QualiTypeSelect';
Vue.regist(SwbQualiTypeSelect);

//资质类型选择
export function showQualiTypeSelectDialog(dlgArgs, callback, thisArg) {
    let merchantType = dlgArgs['merchantType'];
    let merchantTypeName = merchantType == 4 ? "服务商 " : (merchantType == 2 ? "供应商 " : "");
    //
    let theDlg = Vue.$showDialog({
        title: merchantTypeName + "资质类型选择",
        width: 900,
        height: 600,
        cancelVisible: true,
        okVisible: true,
        template: '<div><swb-quali-type-select ref="swb-quali-type-select" :merchantType="merchantType" :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems="initCheckedItems"></swb-quali-type-select></div>',
        data: {
            multiSelect: dlgArgs['multiSelect'],
            initCheckedItem: dlgArgs['initCheckedItem'],
            initCheckedItems: dlgArgs['initCheckedItems'],
            merchantType: dlgArgs['merchantType']
        },
        okClicked: function () {
            let dlgResult = this.$refs['swb-quali-type-select'].getDlgResult() || {};
            let resultData = dlgResult.data || null;
            //
            if(typeof callback == "function") {
                return callback.apply(thisArg, [resultData]);
            }
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/compo/quali/qualiTypeSelectDlg.js
// module id = 3343
// module chunks = 0